<div class="dialog">
  <img src="/assets/icons/special/warning-in-circle.svg" />
  <h1>Payment Failed</h1>
  <p>We tried to charge the account's payment method several times. Update your card now to avoid being downgraded.</p>

  <button
    appButton
    name="confirm"
    location="non-payment-dialog"
    color="primary"
    height="4"
    size="3"
    spacing="full"
    (click)="openUpdateCardDialog()"
  >
    Update Card
  </button>
</div>
